<template>
    <div>

        <template v-for="section in sections">

            <div :class="{'card mb-3': (!section.base_section || section.base_section == '') || !baseSection}" v-if="(!section.base_section && !baseSection) || (baseSection != null && section.base_section == baseSection)">

                <div class="card-header" v-if="section.section_name && (!section.base_section || !baseSection)">
                    <strong>{{ section.section_name }}</strong>

                    <template v-if="section.personnel_field_id && false">
                        <label class="text-muted">Assigned To:</label> {{ getAssignee(section.personnel_field_id) }}
                    </template>
                </div>

                <div :class="{'card-body': (!section.base_section || section.base_section == '') || !baseSection}">
                    <template v-for="field in section.fields">

                        <h4 v-if="field.type == 'Heading'">{{ field.label }}</h4>

                        <div v-else-if="field.parent_field_id == null || shouldRender(field.id, field.parent_field_id)" class="form-group row">
                            <label :class="`${labelSize} col-form-label text-sm-right`">
                                <span :class="{'text-danger': errors['customFields.'+field.id]}">
                                    <template v-if="field.label">
                                        {{ field.label }}
                                        <i v-if="field.help_text" class="fa fa-question-circle" :title="field.help_text"></i>:
                                        <i v-if="field.is_required && (customFields[field.id] === null || customFields[field.id] === undefined) || customFields[field.id] === '' || (Array.isArray(customFields[field.id]) && customFields[field.id].length === 0)" class="fa fa-asterisk text-danger"></i>
                                    </template>
                                </span>
                            </label>
                            <div :class="fieldSize">
                                <template v-if="field.type == 'Text'">
                                    <b-form-input v-model="customFields[field.id]" :placeholder="field.placeholder ? field.placeholder : 'Enter Text Value'" :class="{'is-invalid': errors['customFields.'+field.id]}"></b-form-input>
                                </template>
                                <template v-if="field.type == 'Dropdown'">
                                    <b-form-select v-model="customFields[field.id]" :value="field.allow_multiple ? [] : null" :options="field.options" :multiple="field.allow_multiple" :class="{'is-invalid': errors['customFields.'+field.id]}">
                                        <template v-slot:first v-if="!field.allow_multiple">
                                            <option :value="null">
                                                <template v-if="field.placeholder">-- {{ field.placeholder }} --</template>
                                                <template v-else>-- Select an Option --</template>
                                            </option>
                                        </template>
                                    </b-form-select>
                                    <div v-if="field.allow_multiple">Hold "Ctrl" and click options to select multiple.</div>
                                </template>
                                <template v-if="field.type == 'Radio'">
                                    <b-form-radio-group v-model="customFields[field.id]" :options="field.options" plain :stacked="field.display_vertical" :class="{'is-invalid': errors['customFields.'+field.id]}"></b-form-radio-group>
                                </template>
                                <template v-if="field.type == 'Checkbox'">
                                    <b-form-checkbox-group v-model="customFields[field.id]" :options="buildCheckboxOptions(field.options)" plain :stacked="field.display_vertical" :class="{'is-invalid': errors['customFields.'+field.id]}" :multiple="field.allow_multiple === true"></b-form-checkbox-group>
                                </template>
                                <template v-if="field.type == 'Textarea'">
                                    <template v-if="field.enable_rich_text">
                                        <vue-editor v-model="customFields[field.id]" :placeholder="field.placeholder ? field.placeholder : 'Enter Textarea Value'" rows="4" :editor-toolbar="$root.customVueEditorToolbar"></vue-editor>
                                    </template>
                                    <template v-else>
                                        <b-form-textarea v-model="customFields[field.id]" :placeholder="field.placeholder ? field.placeholder : 'Enter Textarea Value'" rows="4" :class="{'is-invalid': errors['customFields.'+field.id]}"></b-form-textarea>
                                    </template>
                                </template>
                                <template v-if="field.type == 'Date'">
                                    <date-picker v-model="customFields[field.id]" :config="{format: field.format, useCurrent: false}" :placeholder="field.placeholder ? field.placeholder : 'Enter Date Value'" :class="{'is-invalid': errors['customFields.'+field.id]}"></date-picker>
                                </template>

                                <template v-if="field.type == 'Time'">
                                    <date-picker v-model="customFields[field.id]" :config="{format: 'h:mm a', useCurrent: false}" :placeholder="field.placeholder ? field.placeholder : 'Enter Time Value'" :class="{'is-invalid': errors['customFields.'+field.id]}"></date-picker>
                                </template>

                                <template v-if="field.type == 'Email'">
                                    <input v-model="customFields[field.id]" type="email" :placeholder="field.placeholder ? field.placeholder : 'Enter Email Value'" :class="{'form-control': true, 'is-invalid': errors['customFields.'+field.id]}" />
                                </template>

                                <template v-if="field.type == 'Phone'">
                                    <input v-model="customFields[field.id]" type="tel" class="form-control" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" :placeholder="field.placeholder ? field.placeholder : 'Enter Phone Number in format: XXX-XXX-XXXX'" :class="{'is-invalid': errors['customFields.'+field.id]}">
                                </template>

                                <template v-if="field.type == 'Number'">
                                    <input v-model="customFields[field.id]" type="number" class="form-control" :placeholder="field.placeholder ? field.placeholder : 'Enter Number Value'"  :step="field.step ? field.step : 1" :min="field.min" :max="field.max" :class="{'is-invalid': errors['customFields.'+field.id]}" />
                                </template>

                                <template v-if="field.type == 'Paragraph'">
                                    <div class="my-2" :class="field.color ? 'alert alert-'+field.color : 't'" v-html="field.text"></div>
                                </template>

                                <template v-else-if="field.type == 'Employee'">
                                    <employee-select :selectedValues="customFields[field.id] ? customFields[field.id] : {}" @vselected="setLookupValue($event, 'Employee', field.id)" :hasError="errors['customFields.'+field.id] ? true : false"></employee-select>
                                </template>

                                <template v-else-if="field.type == 'Equipment'">
                                    <equipment-select :selectedValues="customFields[field.id] ? customFields[field.id] : {}" @vuselected="setLookupValue($event, 'Equipment', field.id)" :hasError="errors['customFields.'+field.id] ? true : false"></equipment-select>
                                </template>

                                <template v-else-if="field.type == 'Jobsite'">
                                    <jobsite-select :selectedValues="customFields[field.id] ? customFields[field.id] : {}" @vselected="setLookupValue($event, 'Jobsite', field.id)" :hasError="errors['customFields.'+field.id] ? true : false"></jobsite-select>
                                </template>

                                <template v-else-if="field.type == 'User'">
                                    <user-select :selectedValues="customFields[field.id] ? customFields[field.id] : {}" @vuselected="setLookupValue($event, 'User', field.id)" :hasError="errors['customFields.'+field.id] ? true : false"></user-select>
                                </template>

                                <template v-else-if="field.type == 'File'">
                                    <b-form-file :placeholder="field.placeholder ? field.placeholder  :'Upload File'" :drop-placeholder="field.placeholder ? field.placeholder  :'Drop File to Upload'" @input="setFileField($event, field.id)"></b-form-file>

                                    <div v-if="customFields[field.id] && customFields[field.id].file_id" class="mt-2">
                                        <a href="javascript:void(0)" class="text-danger ml-1 btn btn-sm btn-link" v-on:click="deleteFile(customFields[field.id], field.id)"><i class="fa fa-trash"></i></a>
                                        <a :href="`/files/view/${customFields[field.id].file_id}`" target="_blank" title="View File in a New Tab">{{ customFields[field.id].file_name }}</a>
                                    </div>
                                </template>

                                <span v-if="errors['customFields.'+field.id]" class="text-danger">
                                    <span v-for="(err, key) in errors['customFields.'+field.id]">{{ err }}</span>
                                </span>
                            </div>
                        </div>
                    </template>
                    <!-- <hr/>
                    <pre>{{ listString }}</pre> -->
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            sections: {
                type: Array,
                required: true,
            },

            blockType: {
                type: String,
                default: 'card',
            },

            initialValues: {
                //type: Object,
                //default: function () { return {} },
            },

            errors: {
                type: Object,
                default() { return {} },
            },

            baseSection: {
                type: String,
                default: null,
            },

            labelSize: {
                type: String,
                default: 'col-lg-2 col-md-3 col-sm-4'
            },

            fieldSize: {
                type: String,
                default: 'col-lg-8 col-md-8 col-sm-8',
            },

            personnel: {
                type: Array,
                default() { return [] },
            },
        },

        data() {
            return {
                customFields: {},
            }
        },

        computed: {
            listString() {
              return JSON.stringify(this.customFields, null, 2);
            },
        },

        watch: {
            //Emit the Payload
            customFields(newValue, oldValue){
                //Emit
                this.$emit('customFieldsChanged', newValue);
            },
        },

        methods: {
            //Build it
            shouldBuildSection(section){
                //Test
                //if((!section.base_section || section.base_section == '') || !this.baseSection || section.base_section == this.baseSection)

                //Check it
                if(!section.base_section || section.base_section == '')
                {
                    return true;
                }

                //Check if a param was passed in
                if(!this.baseSection)
                {
                    return true;
                }

                //IF we get here, both are not null, matke sure they are equal
                if(section.base_section == this.baseSection)
                {
                    return true;
                }

                //NOPE
                return false;
            },

            //Should Render
            shouldRender(fieldId, parentFieldId){
                //If Parent is NULL, return true
                if(!parentFieldId)
                {
                    return true;
                }

                //Debugging
                //console.log(this.customFields);

                //Get the fields parent_field_id
                for(var i = 0; i < this.sections.length; i++)
                {
                    //Loop through the sections
                    for(var j = 0; j < this.sections[i].fields.length; j++)
                    {
                        //Check the ID
                        if(fieldId == this.sections[i].fields[j].id)
                        {
                            //Log it
                            //console.log(this.sections[i].fields[j]);
                            //console.log(this.customFields);

                            //Check if the value is an array
                            if(Array.isArray(this.customFields[parentFieldId]) && this.customFields[parentFieldId].indexOf(this.sections[i].fields[j].parent_field_value) >= 0)
                            {
                                return true;
                            }
                            else if(this.customFields[parentFieldId] == this.sections[i].fields[j].parent_field_value)
                            {
                                return true;
                            }
                        }
                    }
                }

                //Unset the value
                if(this.customFields[fieldId])
                {
                    delete this.customFields[fieldId];
                }

                //Default
                return false;
            },

            setLookupValue(payload, type, id){

                //Handle it
                switch(type)
                {
                    case 'Employee':
                        //Set it
                        this.customFields[id] = {EmployeeId: payload.EmployeeId, FirstName: payload.FirstName, LastName: payload.LastName, EmployeeNumber: payload.EmployeeNumber};
                        break;

                    case 'Jobsite':
                        //Set it
                        this.customFields[id] = {JobsiteId: payload.JobsiteId, JobsiteNumber: payload.JobsiteNumber, JobsiteName: payload.JobsiteName};
                        break;

                    default:
                        //Set it
                        this.customFields[id] = payload;
                        break;
                }
            },

            setFileField(event, id){
                //Set the value
                this.customFields[id] = event;
            },

            deleteFile(file, fieldId){
                //Confirm with the user
                if(!confirm('Are you sure you want to delete file: '+file.file_name+'?'))
                {
                    return;
                }

                //Send it
                this.$http.post('/files/delete/'+file.file_id)
                    .then(res => {
                        //Alert the user
                        this.$toastr.success('File Deleted');

                        //Splice the file
                        this.customFields[fieldId] = null;
                    });
            },

            buildCheckboxOptions(optionsById){
                //SEtup
                var options = [];

                //Loop
                var keys = Object.keys(optionsById);

                //Loop
                for (var i = 0; i < keys.length; i++)
                {
                    options.push({ value: keys[i], text: optionsById[keys[i]] });
                }

                //SEnd it
                return options;
            },

            getAssignee(personnel_field_id){
                //Check for  null
                if(typeof personnel_field_id == 'undefined' || personnel_field_id == null)
                {
                    return '';
                }

                //Loop and build
                for (var i = 0; i < this.personnel.length; i++)
                {
                    //Check the ID
                    if(this.personnel[i].id === personnel_field_id)
                    {
                        return this.personnel[i].field_label;
                    }
                }
            }
        },

        mounted() {
            //Set
            if(this.initialValues)
            {
                //Set
                this.customFields = this.initialValues;

                //Re-Redner
                this.$forceUpdate();
            }
        }
    }
</script>